export default "__VITE_ASSET__DaCd$oMZ__";